import { ReactNode } from 'react'

import * as S from './styles'
import type { IWrapperProps } from './types'

interface IProps {
  children: ReactNode
  variant?: IWrapperProps['variant']
  padding?: IWrapperProps['padding']
  className?: string
}

// TODO: Remove and use component from hexav2 library when it becomes available
const HexaV2Card = ({
  children,
  variant = 'clear',
  padding = 6,
  className,
}: IProps) => {
  return (
    <S.Wrapper variant={variant} padding={padding} className={className}>
      {children}
    </S.Wrapper>
  )
}

export default HexaV2Card
